import React from 'react';

import Icon from 'components/Icon';

import { useStyles } from './styles';

export const DateTimePickerArrowIcon = () => {
  const classes = useStyles();
  return (
    <Icon
      kind={'arrowDropDown'}
      color={'secondary'}
      classes={{
        root: classes.root
      }}
    />
  );
};
